import React, { Component } from 'react';
import { connect } from 'react-redux';
import OrdersBid from './ordersbid';
import OrdersAsk from './ordersask';

class orders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTab: 'ordersbid',
    };
  }

  changeTab(tab) {
    const { currentTab } = this.state;
    if (currentTab !== tab) {
      this.setState({
        currentTab: tab,
      });
    }
  }

  render() {
    const { user, exchA, exchB, pair, currencySign, toLocaleFixed, isOfType } = this.props;

    let currencyHandle;

    if (user && user.me && user.me.defaults && user.me.defaults.currencyHandle) {
      currencyHandle = user.me.defaults.currencyHandle;
    }

    return (
      <div className="cell panel">
        <div className="panel-label">
          Orderbook
        </div>
        <div className="dual-table table-con">
          <OrdersBid
            pair={pair}
            currencySign={currencySign}
            toLocaleFixed={toLocaleFixed}
            exchA={exchA}
            exchB={exchB}
            isOfType={isOfType}
          />
          <div className="mid-thead">
            <div>
              <div>
                Ask
              </div>
              <div>
                Bid
              </div>
            </div>
            <div>
              <div>
                Ask ({currencySign(currencyHandle || '')})
              </div>
              <div>
                Bid ({currencySign(currencyHandle || '')})
              </div>
            </div>
            <div>
              <div>
                Volume
                { isOfType(exchA, 'METAL') ? (
                  <span style={{ textTransform: 'lowercase' }}> (g)</span>
                ) : (
                  <span> ({exchA})</span>
                )}
              </div>
            </div>
            <div className="hide-mob">
              <div>
                Sum ({exchB})
              </div>
            </div>
            {pair === 'DASHBTC' ? (
              null
            ) : (
              <div>
                <div>
                  Sum
                  { isOfType(exchA, 'METAL') ? (
                    <span style={{ textTransform: 'lowercase' }}> (g)</span>
                  ) : (
                    <span> ({exchA})</span>
                  )}
                </div>
              </div>
            )}
          </div>
          <OrdersAsk
            pair={pair}
            currencySign={currencySign}
            toLocaleFixed={toLocaleFixed}
            exchA={exchA}
            exchB={exchB}
            isOfType={isOfType}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  orders: state.order,
});

export default connect(mapStateToProps)(orders);
